module.exports = __webpack_public_path__ + "assets/img/sub-type-2.b1b023b4.svg";